(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('ComuneDialogController', ComuneDialogController);

    ComuneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Comune'];

    function ComuneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Comune) {
        var vm = this;

        vm.comune = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.comune.id !== null) {
                Comune.update(vm.comune, onSaveSuccess, onSaveError);
            } else {
                Comune.save(vm.comune, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:comuneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
